import { useAuthStore } from '@lib/store';
import { useUserStore } from '@lib/store/user';
import { useEffect } from 'react';

export const useSession = () => {
  const savedState = sessionStorage.getItem('ica_state');
  const initialState = savedState ? JSON.parse(savedState) : null;

  if (initialState) {
    useAuthStore.setState(initialState.auth);
    useUserStore.setState(initialState.user);
  }

  const saveCombinedStateToSession = () => {
    const authState = useAuthStore.getState();
    const userState = useUserStore.getState();

    const combinedState = {
      auth: authState,
      user: userState,
    };

    sessionStorage.setItem('ica_state', JSON.stringify(combinedState));
  };

  useEffect(() => {
    const unsubscribeAuth = useAuthStore.subscribe(() => {
      saveCombinedStateToSession();
    });

    const unsubscribeUser = useUserStore.subscribe(() => {
      saveCombinedStateToSession();
    });

    return () => {
      unsubscribeAuth();
      unsubscribeUser();
    };
  }, []);

  useEffect(() => {
    saveCombinedStateToSession();
  }, []);
};
